import { cn } from '@/lib/utils';

/** Wordmark from design/logo (dark/light files swapped by theme in styles/theme.css). */
export function Logo({ height = 26, className }: { height?: number; className?: string }) {
  const width = Math.round((height * 300) / 72);
  return (
    <span className={cn('inline-flex shrink-0', className)} style={{ height, width }}>
      <img src="/hangar-logo-dark.svg" alt="Hangar" width={width} height={height} className="logo-dark" draggable={false} />
      <img src="/hangar-logo-light.svg" alt="Hangar" width={width} height={height} className="logo-light" draggable={false} />
    </span>
  );
}

/** App icon (orange tile with the arch mark) for the rail, the sign-in hero and the phone app bar. */
export function AppMark({ size = 36, className }: { size?: number; className?: string }) {
  return <img src="/hangar-app-icon.svg" alt="" width={size} height={size} draggable={false} className={cn('shrink-0 rounded-[22%]', className)} style={{ width: size, height: size }} />;
}
